import {CPSConstants} from "commonUtils/enumerations";

export const dialogTitleCommonStyle = {
  dialogTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    p: "0.5rem",
    pl: "0.5rem",
    bgcolor: "#001444",
    color: "#ffffff",
  },
  dialogTitleText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMHEAD,
    fontWeight: CPSConstants.FONTWEIGHT,
  },
};
